var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.cadastroFormulario.destinacaoUsoImovel
    ? _c(
        "div",
        [
          _c("validation-provider", {
            attrs: {
              rules: "required|validaDestinacaoImovel",
              name: "Destinação e Uso do Imóvel/Destinação do Imóvel"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var errors = ref.errors
                    return [
                      _c("span", {
                        model: {
                          value: _vm.isValid,
                          callback: function($$v) {
                            _vm.isValid = $$v
                          },
                          expression: "isValid"
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              1870968712
            )
          }),
          _c(
            "el-row",
            { class: { erro: _vm.errorMessage.length }, attrs: { gutter: 30 } },
            [
              _c("app-label", {
                attrs: {
                  label:
                    "Destinação do Imóvel (pode escolher mais de uma opção).",
                  required: true
                }
              }),
              _c(
                "el-row",
                { staticClass: "checkbox-group", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { type: "checked" },
                          on: { change: _vm.validateAtLeastOne },
                          model: {
                            value:
                              _vm.cadastroFormulario.destinacaoUsoImovel
                                .agricultura,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.destinacaoUsoImovel,
                                "agricultura",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.destinacaoUsoImovel.agricultura"
                          }
                        },
                        [_vm._v("Agricultura")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { type: "checked" },
                          on: { change: _vm.validateAtLeastOne },
                          model: {
                            value:
                              _vm.cadastroFormulario.destinacaoUsoImovel
                                .pecuaria,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.destinacaoUsoImovel,
                                "pecuaria",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.destinacaoUsoImovel.pecuaria"
                          }
                        },
                        [_vm._v("Pecuária")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { type: "checked" },
                          on: { change: _vm.validateAtLeastOne },
                          model: {
                            value:
                              _vm.cadastroFormulario.destinacaoUsoImovel
                                .silvicultura,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.destinacaoUsoImovel,
                                "silvicultura",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.destinacaoUsoImovel.silvicultura"
                          }
                        },
                        [_vm._v("Silvicultura")]
                      )
                    ],
                    1
                  ),
                  _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .recreacao,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "recreacao",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.recreacao"
                              }
                            },
                            [_vm._v("Recreação")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
                ? _c(
                    "el-row",
                    { staticClass: "checkbox-group", attrs: { gutter: 30 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .educacao,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "educacao",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.educacao"
                              }
                            },
                            [_vm._v("Educação")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .industria,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "industria",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.industria"
                              }
                            },
                            [_vm._v("Indústria")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .pesquisa,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "pesquisa",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.pesquisa"
                              }
                            },
                            [_vm._v("Pesquisa")]
                          )
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .mineracao,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "mineracao",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.mineracao"
                              }
                            },
                            [_vm._v("Mineração")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-row",
                { staticClass: "checkbox-group", attrs: { gutter: 30 } },
                [
                  _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .manejoFlorestal,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "manejoFlorestal",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.manejoFlorestal"
                              }
                            },
                            [_vm._v("Manejo Florestal")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .assistencialHospitalar,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "assistencialHospitalar",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.assistencialHospitalar"
                              }
                            },
                            [_vm._v("Assistencial/Hospitalar")]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { type: "checked" },
                          on: { change: _vm.validateAtLeastOne },
                          model: {
                            value:
                              _vm.cadastroFormulario.destinacaoUsoImovel
                                .servidaoAmbiental,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.destinacaoUsoImovel,
                                "servidaoAmbiental",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.destinacaoUsoImovel.servidaoAmbiental"
                          }
                        },
                        [_vm._v("Servidão Ambiental")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { type: "checked" },
                          on: { change: _vm.validateAtLeastOne },
                          model: {
                            value:
                              _vm.cadastroFormulario.destinacaoUsoImovel
                                .sistemasAgroflorestais,
                            callback: function($$v) {
                              _vm.$set(
                                _vm.cadastroFormulario.destinacaoUsoImovel,
                                "sistemasAgroflorestais",
                                $$v
                              )
                            },
                            expression:
                              "cadastroFormulario.destinacaoUsoImovel.sistemasAgroflorestais"
                          }
                        },
                        [_vm._v("Sistemas Agroflorestais")]
                      )
                    ],
                    1
                  ),
                  _vm.tipoCadastro && _vm.tipoCadastro !== "ONEROSO"
                    ? _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "el-row",
                            {
                              staticClass: "checkbox-group",
                              attrs: { gutter: 30 }
                            },
                            [
                              _c(
                                "el-checkbox",
                                {
                                  attrs: { type: "checked" },
                                  on: { change: _vm.validateAtLeastOne },
                                  model: {
                                    value:
                                      _vm.cadastroFormulario.destinacaoUsoImovel
                                        .outro,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.cadastroFormulario
                                          .destinacaoUsoImovel,
                                        "outro",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "cadastroFormulario.destinacaoUsoImovel.outro"
                                  }
                                },
                                [_vm._v("Outro")]
                              ),
                              _vm.cadastroFormulario.destinacaoUsoImovel.outro
                                ? _c("el-input", {
                                    attrs: {
                                      type: "text",
                                      placeholder: "Descrição outro"
                                    },
                                    model: {
                                      value:
                                        _vm.cadastroFormulario
                                          .destinacaoUsoImovel.descricaoOutro,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.cadastroFormulario
                                            .destinacaoUsoImovel,
                                          "descricaoOutro",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cadastroFormulario.destinacaoUsoImovel.descricaoOutro"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm.tipoCadastro && _vm.tipoCadastro === "ONEROSO"
                ? _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-row",
                        {
                          staticClass: "checkbox-group",
                          attrs: { gutter: 30 }
                        },
                        [
                          _c(
                            "el-checkbox",
                            {
                              attrs: { type: "checked" },
                              on: { change: _vm.validateAtLeastOne },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .outro,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "outro",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.outro"
                              }
                            },
                            [_vm._v("Outro")]
                          ),
                          _vm.cadastroFormulario.destinacaoUsoImovel.outro
                            ? _c("el-input", {
                                attrs: {
                                  type: "text",
                                  placeholder: "Descrição outro"
                                },
                                model: {
                                  value:
                                    _vm.cadastroFormulario.destinacaoUsoImovel
                                      .descricaoOutro,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.cadastroFormulario
                                        .destinacaoUsoImovel,
                                      "descricaoOutro",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "cadastroFormulario.destinacaoUsoImovel.descricaoOutro"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.errorMessage.length
            ? _c("span", { staticClass: "erro-message" }, [
                _vm._v(_vm._s(_vm.errorMessage))
              ])
            : _vm._e(),
          _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name: "Destinação e Uso do Imóvel/Possui Reserva Legal"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: {
                              label: "Possuí Reserva Legal?",
                              required: true
                            }
                          }),
                          _c(
                            "el-radio",
                            {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { label: "SIM" },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .possuiReservaLegal,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "possuiReservaLegal",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal"
                              }
                            },
                            [_vm._v("Sim")]
                          ),
                          _c(
                            "el-radio",
                            {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { label: "NAO" },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .possuiReservaLegal,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "possuiReservaLegal",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal"
                              }
                            },
                            [_vm._v("Não")]
                          ),
                          _c(
                            "el-radio",
                            {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { label: "NAO_SABE" },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .possuiReservaLegal,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel,
                                    "possuiReservaLegal",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal"
                              }
                            },
                            [_vm._v("Não sabe responder")]
                          )
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3806387147
                )
              })
            ],
            1
          ),
          _vm.cadastroFormulario.destinacaoUsoImovel.possuiReservaLegal ===
          "SIM"
            ? _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required|areaReservaLegal",
                          name: "Destinação e Uso do Imóvel/Área Reserva Legal"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: { label: "Área:", required: true }
                                  }),
                                  _c(
                                    "el-input",
                                    {
                                      directives: [
                                        {
                                          name: "mask-decimal",
                                          rawName: "v-mask-decimal.br",
                                          value: 4,
                                          expression: "4",
                                          modifiers: { br: true }
                                        }
                                      ],
                                      class: { erro: errors.length },
                                      attrs: {
                                        "data-vv-delay": "10",
                                        name: "ÁreaReservaLegal",
                                        maxlength: 19
                                      },
                                      model: {
                                        value: _vm.areaLegal,
                                        callback: function($$v) {
                                          _vm.areaLegal = $$v
                                        },
                                        expression: "areaLegal"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("hectare(s)")
                                      ])
                                    ],
                                    2
                                  ),
                                  errors.length
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2890288881
                        )
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required|percentualAreaReservaLegal",
                          name:
                            "Destinação e Uso do Imóvel/Percentual Área Reserva Legal"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Percentual Utilizado:",
                                      required: true
                                    }
                                  }),
                                  _c(
                                    "el-input",
                                    {
                                      directives: [
                                        {
                                          name: "mask-decimal",
                                          rawName: "v-mask-decimal.br",
                                          value: 2,
                                          expression: "2",
                                          modifiers: { br: true }
                                        }
                                      ],
                                      class: { erro: errors.length },
                                      attrs: {
                                        "data-vv-delay": "10",
                                        name: "Percentual",
                                        maxlength: 6
                                      },
                                      model: {
                                        value: _vm.percentualArealegal,
                                        callback: function($$v) {
                                          _vm.percentualArealegal = $$v
                                        },
                                        expression: "percentualArealegal"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("%")
                                      ])
                                    ],
                                    2
                                  ),
                                  errors.length
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          2863237005
                        )
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c("app-divider", { attrs: { label: "Informações de Produção" } }),
          _c(
            "el-row",
            { staticClass: "labelDiv", attrs: { gutter: 30 } },
            [
              _c("validation-provider", {
                attrs: {
                  rules: "required",
                  name:
                    "Destinação e Uso do Imóvel/possui comprovante de produtividade"
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function(ref) {
                        var errors = ref.errors
                        return [
                          _c("app-label", {
                            attrs: {
                              label: "Possui comprovante de produtividade?",
                              required: true
                            }
                          }),
                          _c(
                            "el-radio",
                            {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { label: true },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .produtividade.possuiComprovante,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel
                                      .produtividade,
                                    "possuiComprovante",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.produtividade.possuiComprovante"
                              }
                            },
                            [_vm._v("Sim")]
                          ),
                          _c(
                            "el-radio",
                            {
                              staticClass: "input",
                              class: { erro: errors.length },
                              attrs: { label: false },
                              model: {
                                value:
                                  _vm.cadastroFormulario.destinacaoUsoImovel
                                    .produtividade.possuiComprovante,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.cadastroFormulario.destinacaoUsoImovel
                                      .produtividade,
                                    "possuiComprovante",
                                    $$v
                                  )
                                },
                                expression:
                                  "cadastroFormulario.destinacaoUsoImovel.produtividade.possuiComprovante"
                              }
                            },
                            [_vm._v("Não")]
                          ),
                          errors.length
                            ? _c("span", { staticClass: "help erro" }, [
                                _vm._v(_vm._s(errors[0]))
                              ])
                            : _vm._e()
                        ]
                      }
                    }
                  ],
                  null,
                  false,
                  3868685090
                )
              })
            ],
            1
          ),
          _vm.cadastroFormulario.destinacaoUsoImovel.produtividade
            .possuiComprovante
            ? _c(
                "el-row",
                { staticClass: "labelDiv", attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("validation-provider", {
                        attrs: {
                          rules: "required",
                          name: "Destinação e Uso do Imóvel/Tipo de Comprovante"
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function(ref) {
                                var errors = ref.errors
                                return [
                                  _c("app-label", {
                                    attrs: {
                                      label: "Tipo de comprovante:",
                                      required: true
                                    }
                                  }),
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input-select",
                                      class: { erro: errors.length },
                                      attrs: { placeholder: "Selecione" },
                                      model: {
                                        value:
                                          _vm.cadastroFormulario
                                            .destinacaoUsoImovel.produtividade
                                            .tipo,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.cadastroFormulario
                                              .destinacaoUsoImovel
                                              .produtividade,
                                            "tipo",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "cadastroFormulario.destinacaoUsoImovel.produtividade.tipo"
                                      }
                                    },
                                    _vm._l(_vm.tiposComprovante, function(
                                      tipo
                                    ) {
                                      return _c("el-option", {
                                        key: tipo.id,
                                        attrs: {
                                          label: tipo.nome,
                                          value: tipo.codigo
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  errors.length
                                    ? _c("span", { staticClass: "help erro" }, [
                                        _vm._v(_vm._s(errors[0]))
                                      ])
                                    : _vm._e()
                                ]
                              }
                            }
                          ],
                          null,
                          false,
                          4169921447
                        )
                      })
                    ],
                    1
                  ),
                  _vm.cadastroFormulario.destinacaoUsoImovel.produtividade
                    .tipo === "DAP" ||
                  _vm.cadastroFormulario.destinacaoUsoImovel.produtividade
                    .tipo === "DRP"
                    ? _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c("validation-provider", {
                            attrs: {
                              rules: "required",
                              name:
                                "Destinação e Uso do Imóvel/Número do comprovante"
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: _vm.getLabel(),
                                          required: true
                                        }
                                      }),
                                      _vm.cadastroFormulario.destinacaoUsoImovel
                                        .produtividade.tipo === "DAP"
                                        ? _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            model: {
                                              value:
                                                _vm.cadastroFormulario
                                                  .destinacaoUsoImovel
                                                  .produtividade.dap,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.cadastroFormulario
                                                    .destinacaoUsoImovel
                                                    .produtividade,
                                                  "dap",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "cadastroFormulario.destinacaoUsoImovel.produtividade.dap"
                                            }
                                          })
                                        : _vm._e(),
                                      _vm.cadastroFormulario.destinacaoUsoImovel
                                        .produtividade.tipo === "DRP"
                                        ? _c("el-input", {
                                            staticClass: "input",
                                            class: { erro: errors.length },
                                            model: {
                                              value:
                                                _vm.cadastroFormulario
                                                  .destinacaoUsoImovel
                                                  .produtividade.drp,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.cadastroFormulario
                                                    .destinacaoUsoImovel
                                                    .produtividade,
                                                  "drp",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "cadastroFormulario.destinacaoUsoImovel.produtividade.drp"
                                            }
                                          })
                                        : _vm._e(),
                                      errors.length
                                        ? _c(
                                            "span",
                                            { staticClass: "help erro" },
                                            [_vm._v(_vm._s(errors[0]))]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              829898830
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e(),
          _vm.cadastroFormulario.destinacaoUsoImovel.produtividade
            .possuiComprovante
            ? _c(
                "el-row",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { gutter: 30 }
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("app-documentos-retificacao-destinacao-uso-imovel", {
                        attrs: {
                          maxSize: 20,
                          "valid-extensions": _vm.extensoes,
                          documentos: _vm.documentosProdutividade,
                          tiposDocumentos: [],
                          observer: this.$refs.validation,
                          isDocumentoImagex: true,
                          titulo: "Documentação",
                          aba: "DestinacaoUsoImovel",
                          idUploadDocumento: "appUploadDocumentosInteressado"
                        },
                        on: {
                          addedDoc: _vm.handleDocs,
                          removedDoc: _vm.removerDocs
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-row",
            { staticClass: "div", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Atividade:", required: false }
                  }),
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Selecione" },
                      on: {
                        change: function($event) {
                          return _vm.changeTipoAtividade()
                        }
                      },
                      model: {
                        value: _vm.tipoAtividade,
                        callback: function($$v) {
                          _vm.tipoAtividade = $$v
                        },
                        expression: "tipoAtividade"
                      }
                    },
                    _vm._l(_vm.atividades, function(tipo) {
                      return _c("el-option", {
                        key: tipo.id,
                        attrs: { label: tipo.label, value: tipo.codigo }
                      })
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.tipoAtividade
            ? _c("app-divider", {
                attrs: { label: _vm.getLabelProdutividadeTipo() }
              })
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "ruleForm",
              attrs: { model: _vm.ruleForm, rules: _vm.rules }
            },
            [
              _vm.tipoAtividade
                ? _c(
                    "el-row",
                    {
                      staticStyle: { "padding-top": "20px" },
                      attrs: { gutter: 30 }
                    },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 8 } },
                        [
                          _c("validation-provider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var errors = ref.errors
                                    return [
                                      _c("app-label", {
                                        attrs: {
                                          label: "Tipo:",
                                          required: true
                                        }
                                      }),
                                      _c(
                                        "el-form-item",
                                        { attrs: { prop: "tipoDaAtividade" } },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              class: { erro: errors.length },
                                              attrs: {
                                                placeholder: "Selecione"
                                              },
                                              model: {
                                                value:
                                                  _vm.ruleForm.tipoDaAtividade,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.ruleForm,
                                                    "tipoDaAtividade",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "ruleForm.tipoDaAtividade"
                                              }
                                            },
                                            _vm._l(_vm.listaDoTipo, function(
                                              tipo
                                            ) {
                                              return _c("el-option", {
                                                key: tipo.id,
                                                attrs: {
                                                  label: tipo.label,
                                                  value: tipo.codigo
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2513851443
                            )
                          })
                        ],
                        1
                      ),
                      _vm.ruleForm.tipoDaAtividade === "OUTROS"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Descrição:", required: true }
                              }),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "descricao" } },
                                [
                                  _c("el-input", {
                                    attrs: { "data-vv-delay": "10" },
                                    model: {
                                      value: _vm.ruleForm.descricao,
                                      callback: function($$v) {
                                        _vm.$set(_vm.ruleForm, "descricao", $$v)
                                      },
                                      expression: "ruleForm.descricao"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tipoAtividade === "SEMOVENTES"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: {
                                  label: "Número de Cabeças:",
                                  required: true
                                }
                              }),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "cabecas" } },
                                [
                                  _c("el-input-number", {
                                    attrs: {
                                      "data-vv-delay": "10",
                                      controls: false
                                    },
                                    model: {
                                      value: _vm.ruleForm.cabecas,
                                      callback: function($$v) {
                                        _vm.$set(_vm.ruleForm, "cabecas", $$v)
                                      },
                                      expression: "ruleForm.cabecas"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tipoAtividade !== "EDIFICACOES" &&
                      _vm.tipoAtividade !== "SEMOVENTES"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Área:", required: true }
                              }),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "areaDaAtividade" } },
                                [
                                  _c(
                                    "el-input",
                                    {
                                      directives: [
                                        {
                                          name: "mask-decimal",
                                          rawName: "v-mask-decimal.br",
                                          value: 4,
                                          expression: "4",
                                          modifiers: { br: true }
                                        }
                                      ],
                                      attrs: {
                                        "data-vv-delay": "10",
                                        maxlength: 19
                                      },
                                      model: {
                                        value: _vm.ruleForm.areaDaAtividade,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.ruleForm,
                                            "areaDaAtividade",
                                            $$v
                                          )
                                        },
                                        expression: "ruleForm.areaDaAtividade"
                                      }
                                    },
                                    [
                                      _c("template", { slot: "append" }, [
                                        _vm._v("hectare(s)")
                                      ])
                                    ],
                                    2
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tipoAtividade === "EDIFICACOES"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Área:", required: true }
                              }),
                              _c(
                                "el-row",
                                { staticClass: "flex", attrs: { gutter: 30 } },
                                [
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "areaDaAtividade" } },
                                    [
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "mask-decimal",
                                            rawName: "v-mask-decimal.br",
                                            value: 4,
                                            expression: "4",
                                            modifiers: { br: true }
                                          }
                                        ],
                                        attrs: {
                                          "data-vv-delay": "10",
                                          maxlength: 19
                                        },
                                        model: {
                                          value: _vm.ruleForm.areaDaAtividade,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.ruleForm,
                                              "areaDaAtividade",
                                              $$v
                                            )
                                          },
                                          expression: "ruleForm.areaDaAtividade"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    { attrs: { prop: "unidadeMedida" } },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: {
                                            placeholder: "Unidade de Medida"
                                          },
                                          model: {
                                            value: _vm.ruleForm.unidadeMedida,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.ruleForm,
                                                "unidadeMedida",
                                                $$v
                                              )
                                            },
                                            expression: "ruleForm.unidadeMedida"
                                          }
                                        },
                                        _vm._l(_vm.medidas, function(tipo) {
                                          return _c("el-option", {
                                            key: tipo.id,
                                            attrs: {
                                              label: tipo.label,
                                              value: tipo.codigo
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.tipoAtividade === "OUTRAS_ATIVIDADES"
                        ? _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c("app-label", {
                                attrs: { label: "Observações:", required: true }
                              }),
                              _c(
                                "el-form-item",
                                { attrs: { prop: "observacaoDaAtividade" } },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.ruleForm.observacaoDaAtividade,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.ruleForm,
                                          "observacaoDaAtividade",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "ruleForm.observacaoDaAtividade"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _vm.tipoAtividade
            ? _c(
                "el-row",
                {
                  staticStyle: { "padding-top": "20px" },
                  attrs: { gutter: 30 }
                },
                [
                  _c(
                    "el-col",
                    { staticClass: "row-buttons", attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "el-icon-error",
                          attrs: { round: "round" },
                          on: { click: _vm.limpaCampos }
                        },
                        [_vm._v("  cancelar")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { staticClass: "row-buttons-sucess", attrs: { span: 12 } },
                    [
                      _c(
                        "el-button",
                        {
                          staticClass: "el-icon-circle-plus",
                          attrs: { type: "success", round: "round" },
                          on: {
                            click: function($event) {
                              return _vm.submitForm("ruleForm")
                            }
                          }
                        },
                        [_vm._v("  adicionar")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.possuiListaAtividades
            ? _c(
                "div",
                { staticClass: "class-divider" },
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", { staticClass: "texto-paragrafo" }, [
                      _vm._v("Listagem de Atividades")
                    ])
                  ]),
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("div", { staticClass: "row" }, [
                      _c("p", { staticClass: "texto-paragrafo" }, [
                        _vm._v("Total da área em uso:")
                      ]),
                      _c("p", [_vm._v("  " + _vm._s(_vm.getAreas))])
                    ])
                  ])
                ],
                1
              )
            : _vm._e(),
          _vm.cadastroFormulario.destinacaoUsoImovel.semoventes.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-collapse",
                    { attrs: { accordion: "accordion" } },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Semoventes (Animais)", name: "1" } },
                        [
                          _c("app-table-listagem-atividades", {
                            attrs: {
                              listagem:
                                _vm.cadastroFormulario.destinacaoUsoImovel
                                  .semoventes,
                              tipoCodigoAtividade: "SEMOVENTES"
                            },
                            on: { deletaItemLista: _vm.deletaItemLista }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.cadastroFormulario.destinacaoUsoImovel.edificacoes.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-collapse",
                    { attrs: { accordion: "accordion" } },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Edificações", name: "2" } },
                        [
                          _c("app-table-listagem-atividades", {
                            attrs: {
                              listagem:
                                _vm.cadastroFormulario.destinacaoUsoImovel
                                  .edificacoes,
                              tipoCodigoAtividade: "EDIFICACOES"
                            },
                            on: { deletaItemLista: _vm.deletaItemLista }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.cadastroFormulario.destinacaoUsoImovel.culturasPermanentes
            .length > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-collapse",
                    { attrs: { accordion: "accordion" } },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Culturas Permanentes", name: "3" } },
                        [
                          _c("app-table-listagem-atividades", {
                            attrs: {
                              listagem:
                                _vm.cadastroFormulario.destinacaoUsoImovel
                                  .culturasPermanentes,
                              tipoCodigoAtividade: "CULTURA_PERMANENTE"
                            },
                            on: { deletaItemLista: _vm.deletaItemLista }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.cadastroFormulario.destinacaoUsoImovel.culturasTemporarias
            .length > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-collapse",
                    { attrs: { accordion: "accordion" } },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Culturas Temporarias", name: "4" } },
                        [
                          _c("app-table-listagem-atividades", {
                            attrs: {
                              listagem:
                                _vm.cadastroFormulario.destinacaoUsoImovel
                                  .culturasTemporarias,
                              tipoCodigoAtividade: "CULTURA_TEMPORARIA"
                            },
                            on: { deletaItemLista: _vm.deletaItemLista }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm.cadastroFormulario.destinacaoUsoImovel.outrasAtividades.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "el-collapse",
                    { attrs: { accordion: "accordion" } },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Outras Atividades", name: "5" } },
                        [
                          _c("app-table-listagem-atividades", {
                            attrs: {
                              listagem:
                                _vm.cadastroFormulario.destinacaoUsoImovel
                                  .outrasAtividades,
                              tipoCodigoAtividade: "OUTRAS_ATIVIDADES"
                            },
                            on: { deletaItemLista: _vm.deletaItemLista }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e35cc29", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e35cc29","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/DestinacaoUsoImovel.vue
// module id = null
// module chunks = 